module.exports = __webpack_public_path__ + "static/media/Hoist_ios_2.27f45480.jpg";